import { DotLegalDialog, DotLegalTable, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation";
import { TableCell, TableRow } from "@mui/material";
import AnnualWheelActivityStatusChip from "../../../annualWheelActivityStatusChip/AnnualWheelActivityStatusChip";
import { TaskStateEnum } from "../../../AnnualWheel.types";
import { setFirstLetterToLowerCase } from "../../../../common/stringOperations";
import { StatusTimelineDrillDownDialogProps, TimelineTaskItem, useStatusTimelineDrillDownDialog } from "./StatusTimelineDrillDownDialog.hooks";

function StatusTimelineDrillDownDialog(props: StatusTimelineDrillDownDialogProps) {
    const { translateString, translateDate, getChosenLanguage } = useTranslation();
    const { isLoading, data, year, month } = useStatusTimelineDrillDownDialog(props);

    const monthLabel = new Intl.DateTimeFormat(getChosenLanguage(), { month: "long", year: "numeric" }).format(new Date(year, month - 1, 1));

    const headers: Array<ITableHeader<TimelineTaskItem>> = [
        { property: "title", text: translateString("task"), align: "left", showOnMobile: true },
        { property: "status", text: translateString("status"), align: "left", showOnMobile: true },
        { property: "responsibleUserName", text: translateString("responsible"), align: "left", showOnMobile: true },
        { property: "groupEntityName", text: translateString("groupCompany"), align: "left", showOnMobile: true },
        { property: "deadline", text: translateString("deadline"), align: "left", showOnMobile: true },
    ];

    return (
        <DotLegalDialog
            header={`${props.activityName}: ${monthLabel}`}
            buttonOkText={translateString("close")}
            open
            onDialogClose={props.onClose}
            onOkClick={props.onClose}
            size="md"
        >
            <DotLegalTable
                headers={headers}
                defaultOrderBy={"title"}
                data={data}
                isLoading={isLoading}
                hidePagination
                renderRow={(task) => (
                    <TableRow key={task.id}>
                        <TableCell>{task.title}</TableCell>
                        <TableCell>
                            <AnnualWheelActivityStatusChip
                                status={task.status}
                                value={translateString(setFirstLetterToLowerCase(TaskStateEnum[task.status].toString()))}
                            />
                        </TableCell>
                        <TableCell>{task.responsibleUserName ?? ""}</TableCell>
                        <TableCell>{task.groupEntityName ?? translateString("allGroupEntities")}</TableCell>
                        <TableCell>{task.deadline ? translateDate(new Date(task.deadline)) : ""}</TableCell>
                    </TableRow>
                )}
            />
        </DotLegalDialog>
    );
}

export default StatusTimelineDrillDownDialog;
